import React from "react";

const FrameImageLightIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.75 14L5.49619 10.5067C6.2749 9.5161 7.76453 9.4837 8.5856 10.4395L11 13.25M8.915 10.823C9.9522 9.5037 11.3973 7.63455 11.4914 7.51294C11.4947 7.50859 11.4979 7.50448 11.5013 7.50017C12.2815 6.51598 13.7663 6.48581 14.5856 7.43947L17 10.25M4.75 17.25H15.25C16.3546 17.25 17.25 16.3546 17.25 15.25V4.75C17.25 3.64543 16.3546 2.75 15.25 2.75H4.75C3.64543 2.75 2.75 3.64543 2.75 4.75V15.25C2.75 16.3546 3.64543 17.25 4.75 17.25Z",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(FrameImageLightIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;